import React from "react";

import MaterialTable from 'material-table';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import Invitation from 'views/Components/Invitation.jsx'

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT } from 'api-config';
import { getApiHeaders, formatPhoneNumber } from '../../assets/helpers/apiHelper.jsx';
import { convertToDisplayDate } from "../../assets/helpers/dataHelper";

const tableStyle = require('../../assets/style/tableStyle.json');

class Invitations extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      userId: sessionStorage.getItem('userId'),
      invitationsTableData: [{ invitationTo: 'loading...', invitationDate: 'loading...', acceptedName: 'loading...',
                                acceptedDate: 'loading...' }],
      inputDisabled: false,
      submitButtonText: 'send invitation',
      invitationTo: '',
      invitationFrom: 'provider'
    };
  }


  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  resendInvitation(invitationTo) {
    const invitationData = {
      to: invitationTo,
      invitationFrom: this.state.invitationFrom
    }
    axios.post(`${API_ROOT}/invitation/`, invitationData, { headers: getApiHeaders() })
      .then(res => this.handleResendResponse(res));
  }


  handleResendResponse(res) {
    if (this._isMounted) {
      if (res.data.message !== 'success') {
        var alertMessage = '';
        if (res.data.error) {
          alertMessage = res.data.error
        } else {
          alertMessage = 'An unknown error occurred.'
        }
        alert(alertMessage)
      } else {
        this.getSentInvitations()
      }
    }
  }

  componentDidMount(){
    this._isMounted = true;
    this.getSentInvitations()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getSentInvitations() {
    axios.get(`${API_ROOT}/invitation/?userId=`+sessionStorage.getItem('userId'), {headers: getApiHeaders()})
      .then(res => this.setSentInvitations({responseMessage: res.data}));
  }

  setSentInvitations(res) {
    if (this._isMounted) {
      this.setState({
        invitationsTableData: res.responseMessage.map((prop, key) => {
          var invitationToDisplay = prop.invitationTo
          if (!isNaN(invitationToDisplay)) {
            invitationToDisplay = formatPhoneNumber(invitationToDisplay)
          }
          var acceptedDateDisplay = ''
          if (prop.acceptedDatetime) {
            acceptedDateDisplay = convertToDisplayDate(prop.acceptedDatetime)
          }
          return {
            invitationDate: convertToDisplayDate(prop.invitationDatetime),
            invitationTo: invitationToDisplay,
            acceptedDate: acceptedDateDisplay,
            acceptedName: prop.acceptedUserFullName,
            actions: (
              <div>
                {/* use this button to add a edit kind of action */}
                <Button
                  simple
                  onClick={this.resendInvitation.bind(this, prop.invitationTo)}
                  className="edit"
                  color="cirrusBlue"
                  id={"resendInvitationTo_" + prop.invitationTo}
                  name={"resendInvitationTo_" + prop.invitationTo}
                >
                  resend
                </Button>{" "}
              </div>
            )
          };
        })
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Invitation
          showHeader = {true}
          onSendReponse={this.getSentInvitations.bind(this)}
          invitationFrom = {this.state.invitationFrom}
        />
        <Card>
          <CardHeader color="cirrusBlue" icon>
            <CardIcon color="cirrusBlue">
              <PersonAdd />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Sent Invitations</h4>
          </CardHeader>
          <CardBody>
            <MaterialTable
              title=''
              columns={[
                { title: 'sent date', field: 'invitationDate'},
                { title: 'sent to', field: 'invitationTo' },
                { title: 'accepted date', field: 'acceptedDate' },
                { title: 'accepted by', field: 'acceptedName' },
                { title: '', field: 'actions' },
              ]}
              data={this.state.invitationsTableData}
              options={tableStyle}
            />
          </CardBody>
        </Card>

      </div>
    )

  }


}

export default withStyles(userProfileStyles)(Invitations);